import { inject, injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { SpecialSettingsStore } from '../../common/stores/special-settings.store';
import {
    BannerSettings,
    SIGNIN_BANNER_SETTINGS_KEY,
    isBannerInSchedule,
    parseBannerSettings,
} from '../../common/utils/banner-settings';

@injectable()
export class SignInBannerSettingsStore {
    @observable value: BannerSettings | undefined = undefined;
    @observable loaded = false;

    constructor(
        @inject(SpecialSettingsStore) private readonly specialSettings: SpecialSettingsStore
    ) {
        makeObservable(this);
        this.load();
    }

    @action
    load = async () => {
        const raw = await this.specialSettings.getAsync(SIGNIN_BANNER_SETTINGS_KEY);
        runInAction(() => {
            this.value = parseBannerSettings(raw);
            this.loaded = true;
        });
    };

    @computed
    get shouldShow(): boolean {
        if (!this.loaded || !this.value?.enabled) {
            return false;
        }

        const timezoneOffsetMinutes = (window as any).PortalSettings?.timezoneOffsetMinutes;
        return isBannerInSchedule(this.value, timezoneOffsetMinutes);
    }
}
